import React, { useEffect, useState } from "react";
import cx from "classnames";
import styles from "./paperflitedetails.module.scss";
import { Grid, Input, Form, Container, Button, GridRow, GridColumn, Dropdown } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import _, { set } from "lodash";
import { toast } from "react-toastify"
import ConfirmModal from "components/ui/ConfirmModal";
import { updateAccountContact } from "actions/accounts";
import exclamatory from '../../../../../images/exclamatory.svg'
import { useParams} from "react-router-dom";
import SaveChanges from "components/ui/Buttons/SaveButton";



const initMrrOptions = [
  { key: 1, text: "0-50", value: "0-50" },
  { key: 2, text: "50-250", value: "50-250" },
  { key: 3, text: "250-500", value: "250-500" },
  { key: 4, text: "500-1000", value: "500-1000" },
  { key: 5, text: "1000-2000", value: "1000-2000" },
  { key: 6, text: "More than 2000", value: "More than 2000" },
];

const initData = {
  csmId: null,
  mrr: null,
  financeContactId: null
}

export default function PaperfliteDetails({ account }) {

  const dispatch = useDispatch()

  const [open, setOpen] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  const [error, setError] = useState(null);

  const [managerOptions, setManagerOptions] = useState([]);
  const [mrrOptions, setMrrOptions] = useState(initMrrOptions);

  const [accountObj, setAccountObj] = useState(initData);
  const [initAccountObj, setInitAccountObj] = useState(initData);

  const adminAppUsers = useSelector((state) => _.get(state, "accounts.adminAppUsers"));
  const updatingAccount = useSelector((state) => state.accounts.updatingCSM);
 
  const [disableSave, setDisableSave] = useState(false);
  const [indexValue,setIndexValue] = useState(0);

  const params = useParams();
  if (!_.isEmpty(adminAppUsers) && _.isEmpty(managerOptions)) {
    let options = _.map(adminAppUsers, (user) => {
      return { key: user.id, text: user.name, value: user.id };
    });

    setManagerOptions(options);

    console.log("manager: ", options);
  } 

  useEffect(() => {
    onSetContact();
    setInitialRender(false);
    setError(null);
  }, [account]);

  const onSetContact = () => {

    if (account !== null && account !== undefined) {

      let data = { ...initData };
      if (account.csm !== null && account.csm !== undefined) {
        data.csmId = account.csm.id;
      }

      if (account.financeContact !== null && account.financeContact !== undefined) {
        data.financeContactId = account.financeContact.id;
      }

      data.mrr = account.mrr;

      setAccountObj(data);
      setInitAccountObj(data);
    }
  }

  useEffect(() => {
    if (!initialRender && updatingAccount && !updatingAccount.updating) {

      if (updatingAccount.success) {
        toast.success(`Successfully updated ${account.name}`);
      } else {
        toast.error(`failed to update ${account.name}`);
      }
    }
  }, [updatingAccount]);

  useEffect(() => {
    if (_.isEqual(initAccountObj, accountObj)) {
      setDisableSave(true);
    }
    else {
      setDisableSave(false);
    }
  }, [accountObj])

  const onSaveChangesConfirm = () => {
    dispatch(updateAccountContact({ id: account.id, data: accountObj }))
    setOpen(false);
  }

  const onSaveChanges = (e) => {
    if (!accountObj.csmId || !accountObj.financeContactId || !accountObj.mrr) {
      setError("Please fill all the fields");
      setDisableSave(true);
      return;
    }

    setDisableSave(false);
    setError(null);
    setOpen(true);
  };

  const onCancelChanges = (e) => {
    e.preventDefault();
    setOpen(false);
  };

  const onReset = (e) => {
    e.preventDefault();

    onSetContact();
    setOpen(false);
  };
  const handleOnMRRChange = (value) =>{

   const updatedValue = value < 0 ? 0: value;
   setAccountObj({ ...accountObj, mrr: updatedValue });
   
  }
  if (params.product === "cleverstory") {
    return null;
  }
  return (
    <Container className={styles.container}>
      <Form>
        <Grid>
          <GridRow>
            <GridColumn>
              <label className={cx(styles.title)}>Paperflite</label>
              <label></label>
            </GridColumn>
          </GridRow>
          <GridRow columns={2}>
            <GridColumn>
              <Form.Field>
                <label>Manager</label>
                <Dropdown
                  placeholder="select a manager"
                  value={accountObj?.csmId}
                  options={managerOptions}
                  onChange={(e, { value }) => {
                    setAccountObj({ ...accountObj, csmId: value });
                  }}
                  className={styles.inputbox}
                  selection
                />

              </Form.Field>
            </GridColumn>

            <GridColumn>
              <Form.Field>
                <label>MRR</label>
                <Input
                type="number"
                  placeholder="select mrr"
                  value={accountObj?.mrr}
                  className={cx(styles.inputbox)}
                  options={mrrOptions}
                  onChange={(e, { value }) => {
                    handleOnMRRChange(value)
                  }}
                />

                </Form.Field>
            </GridColumn>
          </GridRow>
          <GridRow columns={2}>
            <GridColumn>
              <Form.Field className={cx(styles.fields)}>
                <label>Finance Contact</label>

                <Dropdown
                  placeholder="select finance contact"
                  value={accountObj?.financeContactId}
                  options={managerOptions}
                  onChange={(e, { value }) => {
                    setAccountObj({ ...accountObj, financeContactId: value });
                  }}
                  className={styles.inputbox}
                  selection

                />
              </Form.Field>
            </GridColumn>
          </GridRow>
        </Grid>
      </Form>


      <div className={cx(styles.buttonstyles)}>

        {error &&
          <span className={styles.errorMessage}>
            <img src={exclamatory} height="14px" width="14px" alt="error" className={styles.errorIcon} />
            {error}
          </span>
        }
        <SaveChanges onClick={onSaveChanges} disabled={disableSave} />
        <Button className={cx(styles.cancelbutton)} onClick={onReset}>Reset</Button>

      </div>
      <ConfirmModal
        open={open}
        setOpen={setOpen}
        onSave={onSaveChangesConfirm}
        onCancel={onCancelChanges}
        content={`Are you sure want to update ${account ? account.name : ""
          }?`}
      />
    </Container>
  );
}